export const yue = {
  meta: {
    title: 'AuthFlow™ - 使用 JWT 令牌嘅簡單電郵/密碼身份驗證',
    description: '為現代網頁應用程式提供可靠嘅電郵/密碼身份驗證同 JWT 令牌。同複雜嘅平台唔同，我哋專注喺真正行得通嘅方案：開發者可以信賴、安全又簡單嘅登入。',
  },
	nav: {
		home: '主頁',
		features: '功能',
		pricing: '收費',
		compare: '比較',
		contact: '聯絡',
		getStarted: '開始使用',
		signIn: '登入',
	},
	hero: {
		badge: '全球 DevSecOps 團隊信任',
		title: '身份驗證',
		subtitle: '做得啱',
		description: '最好、最快、最安全嘅電郵加密碼身份驗證。唔再用過度複雜平台，我哋只專注最重要：安全 JWT 驗證，簡單就用到。',
		startTrial: '開始免費試用',
		getStarted: '開始使用',
			trialNote: '唔使信用卡 • 10 個每月活躍用戶免費',
		metrics: {
			firstIntegrationValue: '5 分鐘',
			firstIntegrationLabel: '完成首次整合',
			predictableSessionsValue: 'JWT',
			predictableSessionsLabel: '保持可預期嘅 sessions',
			noMazeValue: '零迷宮',
			noMazeLabel: '畀只想 auth 穩定運作嘅團隊',
		},
		missionControlLabel: 'Auth 控制中心',
		missionControlTitle: '用戶驗證，唔使行迷宮',
		missionControlStatus: '穩定',
		sessionLayer: 'Session 層',
		emailPasswordSignIn: '電郵/密碼登入',
		roleAwareVerification: '按角色驗證',
		validated: '已驗證',
		live: '上線中',
		integrationShapeLabel: '整合形態',
		integrationShapeValue: '細 API，清晰流程',
		forTeamsLabel: '適合團隊',
		forTeamsValue: '專注交付產品，而唔係 IAM 專案',
	},
	cta: {
		title: '準備好加上可靠身份驗證？',
		description: '加入揀選簡單有效 JWT 電郵/密碼身份驗證嘅團隊。今日就開始免費試用。',
		startTrial: '開始免費試用',
	},
	dashboard: {
		title: '儀表板',
		users: '用戶',
		activity: '活動',
		settings: '設定',
		logout: '登出',
		profileSettings: '個人設定',
		activityLog: '活動記錄',
		welcome: '歡迎使用你嘅儀表板',
		welcomeBack: '歡迎返嚟，{name}。以下係你身份驗證服務嘅最新狀態。',
		totalUsers: '總用戶數',
		activeUsers: '活躍用戶',
		totalLogins: '總登入次數',
		recentActivity: '最近活動',
		noRecentActivity: '暫時冇最近活動',
		userSettings: '用戶設定',
		organizationOwnerCannotBeManaged: '機構擁有者不可管理',
		configureSettings: '設定配置',
		hereIsWhatsHappening: '以下係你身份驗證服務嘅運行情況。',
		fromLastMonth: '相比上個月',
		monthlyLogins: '每月登入次數',
		successRate: '成功率',
		latestAuthEvents: '最新身份驗證事件同系統更新',
		viewAllActivity: '查看全部活動',
		userManagement: '用戶管理',
		manageApplicationUsers: '管理你應用程式用戶',
		viewAllUsers: '查看全部用戶',
		apiKeys: 'API Key',
		manageApiKeys: '管理你嘅身份驗證 API Keys',
		systemStatus: '系統狀態',
		authenticationApi: '身份驗證 API',
		operational: '運作正常',
		userManagementService: '用戶管理',
		searchUsers: '搜尋用戶...',
		all: '全部',
		active: '活躍',
		inactive: '非活躍',
		lastLogin: '上次登入',
		never: '從未',
		admin: '管理員',
		owner: '擁有者',
		noUsersFound: '找唔到符合條件嘅用戶',
		noUsers: '找唔到用戶',
		for: 'for',
		noApiKeyFound: '找唔到 API Key',
		hideApiKey: '隱藏 API Key',
		showApiKey: '顯示 API Key',
		created: '已建立',
		success: '成功',
		warning: '警告',
		info: '資訊',
		system: '系統',
		justNow: '啱啱',
		minutesAgo: '分鐘前',
		hoursAgo: '小時前',
		daysAgo: '日前',
		notifications: '通知',
		billingReminder: '收費提醒',
		noNewNotifications: '冇新通知',
		logOut: '登出',
	},
	about: {
		title: '關於 AuthFlow™ - 簡單電郵/密碼身份驗證專家',
		description: '了解 AuthFlow™ 提供可靠 JWT 電郵/密碼身份驗證嘅使命。',
		keywords: ['電郵密碼身份驗證', 'JWT 身份驗證公司', '身份驗證專家', '簡單身份驗證', '安全登入公司', '開發者身份驗證', '可靠身份驗證', 'token 身份驗證', '網頁安全', '身份驗證平台'],
		ogTitle: '關於 AuthFlow™ - 簡單電郵/密碼身份驗證專家',
		ogDescription: '了解我哋點樣專注提供可靠 JWT 電郵/密碼身份驗證。',
		hero: {
			badge: '成立於 2023 年',
			title: '我哋正在建立',
			titleAccent: '簡單身份驗證嘅未來',
			description: '令每位開發者都可以輕鬆使用 JWT 電郵/密碼身份驗證。',
		},
		mission: {
			title: '我哋嘅使命',
			description1: '普及安全、token-based、易實作同易維護嘅身份驗證。',
			description2: '以私隱同合規為設計優先，減少資料收集並加密敏感資料。',
			description3: '讓開發者專注做產品，而唔係陷入複雜身份驗證基建。',
		},
		vision: {
			title: '我哋嘅願景',
			description1: '一個身份驗證簡單又可靠嘅世界。',
			description2: '持續創新，打造開發者信任嘅安全登入基建。',
		},
		values: {
			title: '我哋嘅價值',
			subtitle: '引導 AuthFlow™ 一切決策嘅原則。',
			reliableSecurity: { title: '可靠安全', description: '採用經驗證有效嘅安全實踐，唔加無謂複雜度。' },
			developerFirst: { title: 'Developer-First API', description: '專注打造直觀、文件完整、好用嘅開發者工具。' },
			communityDriven: { title: '社群驅動', description: '路線圖由真實開發者需求同意見推動。' },
		},
		team: {
			title: '我哋團隊',
			subtitle: '一班熱誠打造身份驗證未來嘅人。',
			alex: { initials: 'AJ', name: 'Alex Johnson', role: 'CEO & Co-Founder', bio: '曾於大型跨國金融機構擔任 DevSecOps。' },
			sarah: { initials: 'SC', name: 'Sarah Chen', role: 'CTO & Co-Founder', bio: '擁有超過 10 年建立可靠身份驗證系統經驗。' },
			marcus: { initials: 'MR', name: 'Marcus Rodriguez', role: 'Head of Product', bio: '專注開發者體驗同簡單有效登入系統。' },
		},
		stats: { title: 'AuthFlow™ 數據', developers: '信任我哋嘅開發者', authentications: '每月身份驗證次數', uptime: '可用率', monitoring: '安全監控' },
		cta: { title: '加入我哋使命', description: '準備好成為身份驗證革新一份子？', getStarted: '免費開始', contactUs: '聯絡我哋' },
		breadcrumb: { company: '公司', aboutUs: '關於我哋' },
	},
	getStarted: {
		title: 'AuthFlow™ 開始使用 - 電郵/密碼身份驗證設定指南 | JWT API 整合',
		description: '完整指南：用 AuthFlow™ 實作電郵/密碼身份驗證，幾分鐘內就可以設定好 JWT 安全登入。',
		keywords: ['身份驗證設定', '電郵密碼身份驗證', 'JWT 整合', '安全登入指南', '開發者身份驗證', 'API 教學', 'token 身份驗證', '身份驗證 API 指南'],
		ogTitle: 'AuthFlow™ 開始使用 - 電郵/密碼身份驗證設定指南 | JWT API 整合',
		ogDescription: '用 AuthFlow™ 幾分鐘內完成電郵/密碼 + JWT 安全登入設定。',
		breadcrumb: { resources: '資源', getStarted: '開始使用' },
		hero: {
			badge: '快速設定指南',
			title: '由呢度開始',
			titleAccent: '電郵/密碼身份驗證',
			description: '幾分鐘內為你應用加上安全電郵/密碼登入。',
			createAccount: '建立免費帳戶',
		},
		steps: {
			title: '三個簡單步驟實作安全電郵/密碼身份驗證',
			subtitle: '跟住步驟將 AuthFlow™ 端點整合到你 backend。',
			step1: { title: '建立帳戶', description: '註冊 AuthFlow™ 並建立你第一個 project。', signUp: '免費註冊', viewDemo: '睇 Demo' },
			step2: { title: '整合 Auth 端點', description: '由 backend 使用 /auth 端點處理身份驗證。' },
			step3: { title: '加入身份驗證', description: '連接應用並開始使用身份驗證組件。', quickStart: '快速開始', fullDocumentation: '完整文件' },
		},
		apiDocs: { title: '/auth API 端點技術指南', subtitle: '完整技術文件，協助你整合 AuthFlow™ backend 端點。' },
		features: { title: '電郵/密碼身份驗證開箱即用內容', subtitle: '你接好端點，我哋提供可靠 JWT sessions。' },
		cta: { title: '準備好加入可靠電郵/密碼身份驗證？', description: '今日開始免費試用，今日內就可以上線 JWT 身份驗證。', createAccount: '建立免費帳戶', talkToSales: '聯絡銷售' },
		parameters: '參數',
		response: '回應',
		example: '示例',
		runFailureScenario: '以失敗情境執行',
		failureScenarioOn: '失敗情境：已開啟',
		running: '執行中...',
		runCurlConsole: '喺 Console 執行 cURL',
		copied: '已複製！',
		copyCurl: '複製 curl',
		copyBackendExample: '複製 backend 程式碼',
		required: '必填',
		optional: '可選',
		consoleRunning: 'Console 執行中...',
		consoleDemoTitle: 'Linux Console 示範',
		consoleShellLabel: 'bash -- AuthFlow™ Console',
		notesTitle: '備註',
		endpointContent: {
			session: {
				fooBar: {
					summary: '喺 sign-up 或 login 前產生短時效 anti-abuse token。',
					params: {
						identity: 'auth 用戶電郵地址。',
						apiKey: '來自 AuthFlow™ owner dashboard 嘅機構 API key。',
						role: '編碼入暫時 token 嘅 RBAC 角色。預設 user。',
					},
					notes: {
						expires: '呢個 token 45 秒就會過期。',
						freshToken: '每次 sign-up 或 login 前都要即時拎新 fooBar token。',
					},
				},
				signUp: {
					summary: '喺 owner 機構內建立新 auth 用戶。',
					params: {
						foobar: '由 /auth/fooBar 回傳嘅臨時 anti-abuse token。',
						email: '用戶電郵地址。',
						password: '符合 {passwordRule} 嘅密碼。',
						fullname: 'auth 用戶全名。',
						role: '你應用內嘅 RBAC 用戶角色。',
						apiKey: '機構 API key。',
						disclaimed: '儲存喺用戶記錄嘅布林值類型欄位。collection 用 true。',
					},
					notes: {
						successToken: '成功 sign-up 會即時回傳 session token。',
						duplicateRole: '如果同一 email+role 已存在，API 會回傳 409。',
					},
				},
				login: {
					summary: '驗證 auth 用戶，回傳 session token 或 2FA 挑戰。',
					params: {
						foobar: '由 /auth/fooBar 回傳嘅臨時 anti-abuse token。',
						email: '用戶電郵地址。',
						password: '用戶密碼。',
						apiKey: '機構 API key。',
						role: 'RBAC login 用戶角色。',
					},
					notes: {
						tempTokenInsteadOfToken: '如果已啟用 2FA，login 會回傳 tempToken 而唔係 token。',
						exchangeThrough2fa: '之後要經對應 /auth/2fa 驗證 endpoint 交換 tempToken。',
					},
				},
				validate: { summary: '驗證 auth 用戶 session token。', params: { sessionToken: 'RS512 JWT session token。', email: '用戶電郵地址。' } },
				me: { summary: '對有效 session 回傳目前 auth-user 個人資料。', params: { sessionToken: 'RS512 JWT session token。' } },
				logout: { summary: '登出目前 auth 用戶。', params: { sessionToken: 'RS512 JWT session token。', email: '用戶電郵地址。' } },
			},
			passwordManagement: {
				forgotPassword: { summary: '要求 auth 用戶密碼重設電郵（防列舉回應）。', params: { email: 'auth 用戶電郵地址。', apiKey: '機構 API key。', role: 'auth 用戶角色。預設 user。' } },
				resetPassword: { summary: '用有效重設 token 重設 auth 用戶密碼。', params: { token: '電郵連結入面嘅重設 token。', newPassword: '符合 {passwordRule} 嘅新密碼。' } },
				changePassword: { summary: '更改已登入 auth 用戶密碼。', params: { sessionToken: '目前 RS512 JWT session token。', email: 'session token 入面編碼嘅 email。', oldPassword: '確認用途嘅目前密碼。', newPassword: '符合 {passwordRule} 嘅新密碼。' } },
			},
			emailVerification: {
				verifyEmail: {
					summary: '用 AuthFlow™ 電郵提供嘅 token 驗證 auth 用戶電郵。',
					params: { token: '電郵驗證連結內嘅驗證 token。' },
					notes: { openedFromEmail: '呢個 endpoint 通常由點擊電郵驗證連結開啟。', frontendHostedProxy: 'AuthFlow™ 亦支援經 /verify-email 做 frontend-hosted 驗證代理。' },
				},
				resendVerifyEmail: { summary: '當帳戶未驗證時重發驗證電郵。', params: { foobar: '由 /auth/fooBar 回傳嘅臨時 token。', email: 'auth 用戶電郵地址。', apiKey: '機構 API key。', role: 'auth 用戶角色。預設 user。' } },
			},
			twoFactor: {
				enable: { summary: '為 auth 用戶產生 TOTP secret 同 QR code。', params: { sessionToken: '目前 session token。', email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。' } },
				verifySetup: { summary: '驗證初始 TOTP code 並啟用 2FA。', params: { sessionToken: '目前 session token。', email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。', totpCode: 'Authenticator app 嘅 6 位數 code。', secret: '由 /auth/2fa/enable 回傳嘅 TOTP secret。' } },
				disable: { summary: '停用 auth 用戶 TOTP 2FA。', params: { sessionToken: '目前 session token。', email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。', password: '目前密碼。' } },
				verify2fa: { summary: '用 login tempToken + TOTP code 交換 session token。', params: { tempToken: '2FA 已啟用時 /auth/login 回傳嘅 tempToken。', email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。', totpCode: '6 位數 authenticator code。' } },
				backupEmail: { summary: '用 login tempToken 發送備援 email OTP。', params: { tempToken: '/auth/login 回傳嘅 tempToken。', email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。' } },
				verifyEmailOtp: { summary: '將 email OTP 交換為 session token。', params: { email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。', emailOtp: '電郵送達嘅 6 位數 code。' } },
				recoveryCodes: { summary: '重新產生 auth 用戶 recovery codes。', params: { sessionToken: '目前 session token。', email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。', password: '目前密碼。' } },
				verifyRecovery: { summary: '用 recovery code 交換 session token。', params: { email: 'auth 用戶電郵。', apiKey: '機構 UUID。', role: 'auth 用戶角色。', recoveryCode: '之前回傳嘅其中一個 8 字元 recovery code。' } },
			},
			environment: {
				baseUrl: '公開 API origin。',
				apiKey: 'Owner dashboard API key。只可以 server-side 儲存。',
				defaultRole: '你分配俾 auth 用戶嘅 role/RBAC 值。',
			},
		},
		console: {
			launching: '啟動 AuthFlow™ Linux Console v1.0 ...',
			connected: '已連接 api.authflow.net',
			sending: '> 傳送中 {method} {path}',
			waiting: '> 等待回應 ...',
			processExited: '[程序已結束，代碼 {code}]',
			status: {
				defaultSuccess: 'HTTP/1.1 200 OK (示例)',
				signup: { success: 'HTTP/1.1 201 Created (示例)', alt409: '# 備選：當 email+role 已存在時為 HTTP/1.1 409 Conflict' },
				login: { success: 'HTTP/1.1 200 OK (示例)', alt2fa: '# 備選：啟用 2FA 時回傳 requires2FA/tempToken payload' },
				verifyEmail: { success: 'HTTP/1.1 200 OK (示例)', alt401: '# 備選：驗證 token 無效或過期時 HTTP/1.1 401 Unauthorized' },
				validate: { success: 'HTTP/1.1 200 OK (示例)', alt401: '# 備選：session token 無效或過期時 HTTP/1.1 401 Unauthorized' },
				forgotPassword: { success: 'HTTP/1.1 200 OK (防列舉回應)' },
				changePassword: { success: 'HTTP/1.1 200 OK (示例)', noJsonBody: '# 成功時冇 JSON body' },
			},
			failure: {
				signup: { status: 'HTTP/1.1 409 Conflict (示例)', extra: '# 失敗情境：重複 email+role' },
				login: { status: 'HTTP/1.1 400 Bad Request (示例)', extra: '# 失敗情境：帳密錯誤或角色不匹配' },
				verifyEmail: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：過期驗證 token' },
				validate: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：過期 session token' },
				me: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：sessionToken 缺失或無效' },
				logout: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：sessionToken 無效' },
				changePassword: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：oldPassword 錯誤或 session 過期' },
				resendVerifyEmail: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：foobar token 過期或 api_key 無效' },
				fooBar: { status: 'HTTP/1.1 400 Bad Request (示例)', extra: '# 失敗情境：identity 或 api_key 缺失' },
				forgotPassword: { status: 'HTTP/1.1 400 Bad Request (示例)', extra: '# 失敗情境：email 或 api_key 缺失' },
				resetPassword: { status: 'HTTP/1.1 401 Unauthorized (示例)', extra: '# 失敗情境：reset token 過期' },
				default: { status: 'HTTP/1.1 400 Bad Request (示例)', extra: '# 失敗情境' },
			},
		},
		pageContent: {
			badge: 'Auth 產品參考',
			title: 'AuthFlow™ API 文件',
			titleAccent: '適用於機構擁有者',
			description: '呢個 Get Started 文件講解你機構用戶可用嘅公開 auth API。AuthFlow™ 總共提供 20 條 /auth routes。',
			downloadCollection: '下載 Insomnia Collection',
			createAccount: '建立 Owner 帳戶',
			cloneStarterOnGitHub: 'Clone Next.js Starter',
			starterInfoLabel: '關於 Next.js Starter 嘅重要安全資訊',
			starterWarningTitle: '只限原型同概念驗證用途',
			starterWarningPrototype: 'authflow-nextjs-starter 只適合用嚟製作原型同概念驗證 frontend，唔係生產環境嘅 browser integration。',
			starterWarningSecret: '絕對唔好將 AuthFlow API key 放入生產環境 frontend code、browser 可見嘅環境變數、靜態資源或者 client bundle。任何傳送到 browser 嘅內容，使用者同攻擊者都可以讀取。',
			starterWarningProduction: '生產環境應該透過可信任嘅 server-side backend 或 AuthFlow ExpressJS Proxy 傳送身份驗證請求，並將 API key 保存在 server-side 環境變數或受管理嘅 secret store。',
			apiKeyWarningTitle: '絕對唔好喺生產環境 browser code 暴露 AuthFlow API key。',
			apiKeyWarningBody: 'API key 必須留喺你控制嘅基礎設施。唔好將佢嵌入 JavaScript bundle、HTML、公開環境變數、mobile web 資源、log，或者由 browser 直接發出嘅網絡請求。請使用呢個 ExpressJS Proxy 或你自己嘅 backend，確保 key 留喺 server-side。',
			integrationRulesTitle: '整合規則',
			integrationRulesRules: ['機構擁有者只應該由 server-side code 呼叫 AuthFlow™。', '核心 session routes 同其他路由都需要 owner API key。', 'fooBar 係短時效 anti-abuse token，sign-up/login 前要即時重新取得。', '如果 login 回傳 requires2FA，必須完成其中一個 /auth/2fa 驗證交換流程。'],
			ownerAssetsTitle: 'Owner 資產',
			ownerAssetsText: '請使用你實作團隊可直接匯入 Insomnia 嘅完整 collection。',
			ownerAssetsCollectionName: 'AuthFlow_Consumers.yaml',
			collectionIncludes: 'Collection 包含：',
			collectionItems: ['7 條公開 /auth session routes', '3 條公開 /auth passwordManagement routes', '2 條公開 /auth emailVerification routes', '8 條公開 /auth/2fa routes', 'API key、role/RBAC、session token、TOTP、temp token、recovery code 流程環境變數'],
			checklistTitle: '實作清單',
			checklistSubtitle: '呢個係建議嘅機構 owner workflow，用嚟將 AuthFlow™ 接到你公司身份驗證。',
			configStep: '1. 設定 server-side secrets',
			implementStep: '2. 實作 server-side auth',
			connectStep: '3. 連接 frontend',
			connectStepSecurityNote: '你嘅 browser code 唔應該儲存 AuthFlow™ API secrets，例如 owner API key。',
			implementStepRules: ['呼叫 /auth/fooBar', '呼叫 /auth/signUp 或 /auth/login', '安全儲存 session tokens', '喺受保護路由用 /auth/validate、/auth/me、/auth/changePassword、/auth/logout'],
			connectStepRules: ['提交登入/註冊表單', '當 API 回傳 requires2FA 時處理雙重驗證提示', '將應用程式 sessions 儲存喺安全 cookies', '透過 session 端點回應載入目前用戶'],
			sessionEndpointsTitle: 'Session 端點',
			sessionEndpointsSubtitle: '呢 7 條 routes 對應 backend root endpoint 嘅 authProduct.session。',
			passwordMgmtTitle: '密碼管理端點',
			passwordMgmtSubtitle: '呢 3 條 routes 對應 authProduct.passwordManagement。',
			emailVerificationTitle: '電郵驗證端點',
			emailVerificationSubtitle: '呢 2 條 routes 對應 authProduct.emailVerification。',
			twoFactorTitle: '雙重驗證端點',
			twoFactorSubtitle: '呢 8 條 routes 對應 authProduct.twoFactor。',
			serviceExampleTitle: '服務範例',
			securityRequirementsTitle: '安全要求',
			securityRequirements: ['將 AUTHFLOW_API_KEY 保留於 server-side 並加密。', '建議使用 HTTP-only secure cookies 儲存應用 session。', '回傳受保護資料前先驗證 AuthFlow™ session。', '整合時請明確處理 400、401、404、409、500 回應。'],
			readyCtaTitle: '準備好接好你公司嘅身份驗證？',
			readyCtaDescription: '由可下載 collection 開始，實作安全整合並安全保存 secrets；需要時可用本頁 assistant 協助。',
			proxyTitlePrefix: 'ExpressJS ',
     	 	proxyTitleSuffix: ' Proxy',
			proxyDescriptionPrefix: '你亦可以用自家 ExpressJS backend 代理 AuthFlow backend。呢個係其中一種最安全方式去使用 ',
			proxyDescriptionSuffix: ' 喺你應用 stacks 入面。',
			proxyDetailsRoutes: 'Proxy 會轉發所有 AuthFlow /auth/* 同 /auth/2fa/* routes，並將 API key 留喺 server-side，降低 browser 洩漏風險。',
			proxyDetailsDeploy: 'Proxy 已支援 Vercel 部署，可即時本地開發，並附有 sign-up、login、password flows 同 2FA 驗證實例。',
			proxyButton: '在 GitHub 查看',
		},
	},
	comparisons: {
		hub: {
			breadcrumbRoot: '比較',
			breadcrumbCurrent: 'Auth 產品比較',
			title: 'Auth 產品比較',
			description: '睇下 AuthFlow™ 同最受歡迎嘅身份驗證平台點樣比較。透過並排功能表，你可以更快揀到最適合自己項目嘅 auth 方案。',
			card: {
				firebase: {
					title: 'Firebase vs. Auth0 vs. AuthFlow™',
					description: '比較 Google Firebase Authentication、Auth0 企業方案，同埋以開發者為先嘅 AuthFlow™。你可以更快判斷邊個身份驗證方案最啱你而家嘅 stack。',
				},
				supabase: {
					title: 'Supabase vs. Auth0 vs. AuthFlow™',
					description: '比較 Supabase 嘅 open-source auth、Auth0 企業功能，同埋精簡而專注嘅 AuthFlow™ 認證服務。如果你已經用緊 Supabase ecosystem，會特別有幫助。',
				},
			},
			bullets: {
				core: '核心 auth 功能同安全性',
				rbac: '2FA、RBAC 同多租戶',
				supabaseModel: 'Open source vs. 託管 vs. 專注型',
				pricing: '收費同 vendor lock-in',
				dx: '開發者體驗同設定複雜度',
			},
			viewComparison: '查看比較',
		},
		labels: {
			fullySupported: '完整支援',
			partial: '部分 / 有限制',
			notSupported: '不支援',
			feature: '功能',
			summary: '摘要',
			startFree: '用 AuthFlow™ 免費開始',
			alsoSee: '你亦可以睇:',
			providers: {
				firebase: 'Firebase Auth',
				supabase: 'Supabase Auth',
				auth0: 'Auth0',
				authflow: 'AuthFlow™',
			},
			categories: { core: '核心身份驗證', security: '安全', userOrg: '用戶同機構管理', dx: '開發者體驗', pricing: '收費同彈性' },
		},
		features: {
			emailPassword: '電郵同密碼身份驗證',
			socialLogin: '社交登入 (Google、GitHub 等)',
			magicLinks: 'Magic Links / 免密碼登入',
			smsPhone: 'SMS / 電話號碼身份驗證',
			anonymous: '匿名身份驗證',
			jwt: 'JWT Token 管理',
			rs512: 'RS512 金鑰對簽署',
			twofa: '雙重驗證 (2FA)',
			totp: 'TOTP 驗證器 App (Google Auth、Authy)',
			backupCodes: '2FA 備用碼',
			emailOtp: '經電郵 OTP 做 2FA',
			rateLimiting: 'Rate Limiting',
			emailVerification: '電郵驗證',
			passwordReset: '重設密碼 / 忘記密碼',
			passwordComplexity: '密碼複雜度要求',
			userDashboard: '用戶管理儀表板',
			rbac: '角色為本存取控制 (RBAC)',
			multiTenancy: '多租戶 / 機構',
			perOrgApiKeys: '每個機構獨立 API Key',
			auditLogs: '審計 / 活動日誌',
			userBlocking: '封鎖 / 暫停用戶',
			simpleRest: '簡單 REST API (唔使 SDK)',
			officialSdks: '官方 Client SDK',
			customEmailTemplates: '自訂電郵模板',
			webhooks: 'Webhooks / 事件回調',
			selfHosted: 'Self-hosted 選項',
			openSource: '開放原始碼',
			apiDocs: 'API 文件',
			integratedDb: '整合資料庫 (PostgreSQL)',
			authOnly: '只做 auth (唔需要資料庫)',
			freeTier: '有免費方案',
			flatRate: '可預期固定收費',
			payPerMau: '按 MAU 收費模式',
			lowLockIn: '較低 vendor lock-in',
			lowSetup: '低設定複雜度',
			noEcosystemBuyIn: '唔使綁定整個 ecosystem 都用得',
		},
		notes: {
			firebase2fa: 'Firebase 要升級到 Identity Platform 先有 2FA。',
			firebaseRest: 'Firebase 以 SDK 為主；如果直接用 REST，要自己處理 token exchange。',
			firebaseLockIn: 'Firebase 同 Google/Firebase ecosystem 綁定得比較深。',
			supabaseRls: 'Supabase 用 Postgres 嘅 Row-Level Security (RLS) policy。',
			supabaseDb: 'Supabase Auth 同佢自己嘅 Postgres database 深度整合。',
			supabaseLockIn: 'Open source 可以減少 lock-in，但 auth 層仍然同 Postgres stack 綁得幾緊。',
			supabaseAuthOnly: 'Supabase 可以淨係用嚟做 auth，但本身設計係完整 backend 平台。',
		},
		firebase: {
			breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
			title: 'Firebase vs. Auth0 vs. AuthFlow™',
			description: 'Google Firebase Authentication、Okta Auth0 同 AuthFlow™ 並排比較，方便你為應用程式揀啱嘅 auth 層。',
			summary: {
				firebaseTitle: 'Firebase Authentication',
				firebaseBody: '最適合已經深度使用 Google/Firebase ecosystem 嘅團隊。免費層夠闊、SDK 整合方便，但 ecosystem lock-in 較高，而且 2FA 等進階功能要用 Identity Platform。',
				auth0Title: 'Auth0',
				auth0Body: '三者之中功能最全面，包括 SAML、OIDC、企業 SSO 同大量自訂能力。適合有複雜 enterprise 要求嘅大團隊，但 MAU 一高，收費都會升得好快。',
				authflowTitle: 'AuthFlow™',
				authflowBody: '如果你想要安全而專注嘅電郵/密碼身份驗證，包括 RS512 JWT、2FA 同 RBAC，又唔想綁死大型 ecosystem，AuthFlow™ 會係好選擇。REST API 簡單、收費可預期、設定成本低。',
			},
			alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
		},
		supabase: {
			breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
			title: 'Supabase vs. Auth0 vs. AuthFlow™',
			description: 'Supabase Auth、Auth0 同 AuthFlow™ 並排比較，方便你為應用程式揀啱嘅 auth 層。',
			summary: {
				supabaseTitle: 'Supabase Auth',
				supabaseBody: '適合想要 open-source、可 self-host backend 嘅團隊。Supabase Auth 支援社交登入、magic links，同 Postgres 深度整合；如果你本身已經用緊 Supabase database，就更加合適。',
				auth0Title: 'Auth0',
				auth0Body: '提供最全面嘅功能，包括 SAML、OIDC、企業 SSO 同深度自訂。對有合規要求嘅大型團隊好有吸引力，但每月活躍用戶一多，成本會急速上升。',
				authflowTitle: 'AuthFlow™',
				authflowBody: '如果你需要專注而可靠嘅電郵/密碼身份驗證，支援 RS512 JWT、2FA 同 RBAC，又唔想有平台 lock-in，AuthFlow™ 會更加啱。REST API 簡單、固定收費可預期、設定極少。',
			},
			alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
		},
	},
	features: {
		title: '點解 AuthFlow™ 唔同',
		description: '我哋專注做電郵/密碼 + JWT 身份驗證，呢個就係安全 Web App 嘅核心。唔係乜都做，而係將一件最重要嘅事做到最好。',
		emailPassword: {
			title: '電郵/密碼登入',
			description: '簡單、安全，而且穩定嘅電郵/密碼驗證。唔需要複雜流程，只要用戶容易明白嘅登入體驗。',
		},
		jwtTokens: {
			title: 'JWT Token 管理',
			description: '正確處理 JWT sessions，包括安全儲存同自動更新。採用業界標準 token，易於整合到你嘅 API。',
		},
		developerApi: {
			title: 'Developer-First API',
			description: 'REST API 連完整文件、SDK 同開發者工具。由開發者為 DevSecOps workflow 而設。',
		},
	},
	testimonials: {
		title: '全球開發者都信任',
		testimonial1: {
			text: 'AuthFlow™ 幫我哋慳咗幾個月開發時間。整合順暢，安全功能亦達到企業級。',
			author: 'Sarah Johnson',
			role: 'CTO, TechStart',
		},
		testimonial2: {
			text: '分析儀表板畀到我哋好多用戶行為洞察。係我哋用過最好嘅 auth 方案。',
			author: 'Mike Rodriguez',
			role: 'Lead Developer, AppCorp',
		},
		testimonial3: {
			text: '穩定到好似石咁，同時支援都非常好。用戶好鍾意流暢嘅登入體驗。',
			author: 'Alex Liu',
			role: 'Product Manager, InnovateLab',
		},
	},
	signIn: {
		title: '歡迎返嚟',
		subtitle: '登入你嘅電郵/密碼身份驗證',
		card: {
			title: '機構登入',
			description: '輸入機構擁有者電郵，進入你嘅 JWT 身份驗證儀表板',
		},
		form: {
			email: { label: '電郵', placeholder: 'owner@yourorganization.com' },
			password: { label: '密碼', placeholder: '輸入你嘅密碼' },
			signIn: '登入',
			signingIn: '登入中...',
			noAccount: { text: '未有機構?', link: '立即建立' },
		},
		errors: {
			emailRequired: '必須填寫電郵',
			failed: '登入失敗',
			unexpected: '發生未預期錯誤，請再試。',
		},
		success: { message: '登入成功！' },
		agreement: {
			text: '登入即表示你同意我哋嘅',
			terms: '服務條款',
			and: '同',
			privacy: '私隱政策',
		},
	},
	signUp: {
		title: '建立你嘅機構',
		subtitle: '用電郵/密碼身份驗證開始你嘅機構',
		card: {
			title: '建立機構',
			description: '設定你嘅機構，開始使用電郵/密碼身份驗證同 JWT tokens',
		},
		form: {
			organizationName: { label: '機構名稱', placeholder: 'Your Organization' },
			organizationWebsite: { label: '機構網站', placeholder: 'yourorganization.com' },
			emailOwner: { label: '擁有者電郵', placeholder: 'owner@yourorganization.com' },
			password: { label: '密碼', placeholder: '建立一個高強度密碼' },
			confirmPassword: { label: '確認密碼', placeholder: '再次輸入密碼' },
			agreeToTerms: '我同意服務條款同私隱政策',
			acceptMarketing: '向我發送產品更新同市場推廣電郵',
			createOrganization: '建立機構',
			creatingOrganization: '建立機構中...',
			haveAccount: { text: '已經有帳戶?', link: '登入' },
		},
		errors: {
			organizationNameRequired: '必須填寫機構名稱',
			organizationWebsiteRequired: '必須填寫機構網站',
			emailRequired: '必須填寫電郵',
			passwordRequired: '必須填寫密碼',
			passwordsDoNotMatch: '兩次輸入密碼唔一致',
			agreeToTermsRequired: '你必須同意服務條款同私隱政策',
			failed: '建立機構失敗',
			unexpected: '發生未預期錯誤，請再試。',
		},
		success: { message: '機構建立成功！' },
		trial: {
			description: '今日就開始管理你機構嘅身份驗證。',
			features: {
				emailPassword: '電郵/密碼身份驗證',
				jwtTokens: 'JWT token 安全',
				simpleLogin: '簡單登入',
			},
		},
	},
	common: {
		loading: '載入中...',
		error: '發生錯誤',
		success: '成功',
		cancel: '取消',
		save: '儲存',
		delete: '刪除',
		edit: '編輯',
		view: '查看',
		back: '返回',
		next: '下一步',
		previous: '上一步',
		language: '語言',
	},
	seo: {
		title: 'AuthFlow™ - 簡化而安全嘅身份驗證',
		description: '為網頁應用而設嘅 token-based 身份驗證。易整合、企業級安全、對開發者友善嘅 API。立即開始免費試用。',
		keywords: ['身份驗證', 'auth', '安全', 'API', 'token-based auth', 'JWT', '開發者工具', '網絡安全', '用戶管理'],
	},
	footer: {
		description: '簡單可靠嘅電郵/密碼身份驗證，配合 JWT tokens。獲全球開發者信任。',
		product: '產品',
		resources: '資源',
		company: '公司',
		apiReference: 'API 參考',
		about: '關於',
		support: '支援',
		privacyPolicy: '私隱政策',
		termsOfService: '服務條款',
		copyright: '© 2024 AuthFlow™. 版權所有。',
	},
	pricing: {
		title: 'AuthFlow™ 收費 - 簡單電郵/密碼身份驗證成本',
		description: '針對 JWT 電郵/密碼身份驗證嘅簡單透明收費。免費起步，隨成長擴展。冇隱藏收費。',
		keywords: ['身份驗證收費', '電郵密碼收費', 'JWT 收費', '簡單身份驗證收費', '開發者身份驗證收費', '可靠身份驗證成本', '安全登入收費', 'token 身份驗證收費', '免費身份驗證試用'],
		ogTitle: 'AuthFlow™ 收費 - 簡單電郵/密碼身份驗證成本',
		ogDescription: '揀最適合你需要嘅計劃。免費開始，並用可靠 JWT 電郵/密碼身份驗證一路擴展。',
		hero: {
			title: '簡單、透明嘅',
			titleAccent: '身份驗證收費',
			description: '按你嘅身份驗證需求選擇最佳方案。免費開始，隨住業務成長，用 JWT session tokens 做電郵/密碼身份驗證擴展。',
		},
		breadcrumb: { product: '產品', pricing: '收費' },
		plans: {
			starter: {
				name: 'Starter',
				description: '適合小型專案同測試電郵/密碼身份驗證',
				price: '$0',
				period: '/月',
				features: {
					users: '每月最多 10 位活躍用戶',
					basicAuth: '基礎電郵/密碼身份驗證',
					support: '標準支援',
				},
				cta: '免費開始',
			},
			pro: {
				name: 'Pro',
				description: '適合需要可靠電郵/密碼身份驗證嘅成長型業務',
				price: '$9.99',
				period: '首月，之後 $19.99/月',
				badge: '最受歡迎',
				features: {
					users: '每月活躍用戶無上限',
					advancedAuth: '進階電郵/密碼身份驗證',
					support: '優先支援',
				},
				cta: '開始免費試用',
				monthlyCta: '購買月繳',
				annualCta: '購買年繳',
			},
		},
		faq: {
			title: '常見問題',
			subtitle: '關於我哋電郵/密碼身份驗證收費同方案，你需要知道嘅重點都喺度。',
			questions: {
				mau: { question: '咩先算每月活躍用戶？', answer: '每月活躍用戶（MAU）係指一個曆月內至少成功驗證一次嘅唯一用戶。' },
				changePlans: { question: '可唔可以隨時轉方案？', answer: '可以，你可以隨時升級或降級。變更即時生效，費用按比例計算。' },
				freeTrial: { question: '有冇免費試用？', answer: '有，所有付費方案都提供 3 日免費試用，開始唔需要信用卡。' },
				paymentMethods: { question: '接受咩付款方式？', answer: '我哋接受主要信用卡、Google Pay 同 Apple Pay。' },
			},
		},
		cta: {
			title: '準備好開始未？',
			description: '加入數以千計信任 AuthFlow™ 嘅開發者，使用可靠電郵/密碼身份驗證。今日就開始免費試用。',
			startTrial: '開始免費試用',
			contactSales: '聯絡銷售',
		},
		footer: {
			description: '簡單可靠嘅電郵/密碼身份驗證，配合 JWT tokens。獲全球開發者信任。',
			product: { title: '產品', features: '功能', pricing: '收費', apiReference: 'API 參考' },
			resources: { title: '資源', gettingStarted: '開始使用', apiReference: 'API 參考', support: '支援' },
			company: { title: '公司', about: '關於', privacy: '私隱政策', terms: '服務條款' },
			copyright: '© 2024 AuthFlow™. 版權所有。',
		},
	},
	agent: {
		chatbot: {
			title: 'AuthFlow™ 助手',
			inputPlaceholder: '問下 /auth 或 2FA 整合...',
			greeting: '我會按 AuthFlow™ auth-user 精確合約一步一步幫機構擁有者整合。你可以問 owner API key 設定、/auth endpoints、2FA 流程、Insomnia collection、前後端邊界，或者 Settings 頁面刪除帳戶。',
			downloadIntro: '用呢張直接下載卡，即刻攞到 owner collection 畀你團隊匯入。',
			downloadTitle: '下載 Insomnia Collections',
			downloadButton: '下載',
			noAnswer: '我未收到代理可用嘅回覆。請再問特定 endpoint、2FA 流程，或者 backend 整合步驟。',
			error: '連接助手時發生錯誤。你仍然可以再問 /auth 合約、2FA 流程，或者 Insomnia collection。',
			toolNotFound: '搵唔到工具',
		},
		tools: {
			verificationRecoveryDescription: '電郵驗證同重設密碼 endpoints',
			accountSteps: ['1. 去 https://www.authflow.net/sign-up 以機構擁有者身份註冊', '2. 喺 owner dashboard 建立機構', '3. 喺 dashboard 複製機構 API key', '4. 決定你應用會用嘅 role 值', '5. 下載 AuthFlow™ auth-user 嘅 Insomnia collection', '6. 將 collection 同精確 backend 合約交畀整合團隊'],
			accountManagement: ['如果要永久刪除機構，去 AuthFlow™ dashboard 嘅 Settings 頁。', '喺 Delete Account 區輸入 DELETE 以確認不可還原刪除。'],
			reminder: 'owner API key 只可以放喺公司 backend。',
			environmentNotes: ['AUTHFLOW_API_KEY 只可喺 server 端使用。', 'AUTHFLOW_DEFAULT_ROLE 係可選，但通常有幫助。', 'Frontend 應該呼叫你自己 backend routes，而唔係直接呼叫 AuthFlow™。'],
			backendGuidance: ['喺 /auth/signUp 或 /auth/login 之前即刻攞 /auth/fooBar。', '參數名稱要同公開合約完全一致。', '如果 /auth/login 回傳 requires2FA，就要跟返對應 /auth/2fa route。', '喺 backend routes 驗證同查詢目前用戶，再只將你自己 app session 暴露俾 frontend。'],
			insomniaContains: ['全部 12 個公開 /auth endpoints（包括 verify-email、resend-verify-email、forgot-password、reset-password、deleteUser）', '全部 8 個公開 /auth/2fa endpoints', '包含 API key、role、fooBar token、tempToken、session token、TOTP、email OTP 同 recovery code 流程嘅環境變數'],
			troubleshoot: {
				solutions: {
					cors: '如果瀏覽器直接呼叫 AuthFlow™，先停一停。瀏覽器應該呼叫你 backend，再由 backend 呼叫 AuthFlow™。',
					'401_unauthorized': '檢查 api_key、role 同 email 係咪同 /auth/fooBar 或建立用戶時完全一致。',
					token_validation: '喺 /auth/validate 要用準確嘅 sessionToken + email，唔好同 tempToken 搞亂。',
					connection_failed: '確認 AUTHFLOW_BASE_URL 係 https://api.authflow.net，同埋 backend 可以連到。',
					api_key_invalid: 'owner API key 必須係 dashboard key，並且以 af_ 開頭。',
					foobar_expired: 'fooBar 過期得好快，sign-up/login 前要即刻重新攞。',
					verification_link: '電郵驗證 token 要有效，並以 query 參數傳去 /auth/verify-email。',
					password_reset: '先呼叫 /auth/forgot-password，再用電郵 token 呼叫 /auth/reset-password。',
					two_factor_flow: '如果 login 回傳 requires2FA，tempToken 只可以用喺 /auth/2fa 路由。',
					organization_deletion: '永久刪除機構要去 Settings > Delete Account 輸入 DELETE。',
					other: '請對照公開合約：參數名、HTTP 方法，同 query/body/header 位置。',
				},
				commonIssues: ['Frontend 直接呼叫 AuthFlow™', '/auth/fooBar 或 /auth/login 缺少 api_key 或 role 錯誤', '/auth/changePassword 嘅 oldPassword/newPassword 用錯', 'tempToken 同 sessionToken 搞亂', '驗證 token 過期或無效', '未先呼叫 /auth/forgot-password 就呼叫 /auth/reset-password', 'requires2FA 之後冇完成 2FA 驗證交換', '喺 Settings 流程外嘗試刪除機構'],
			},
		},
	},
} as const
